import React, { useState } from 'react';
import Axios from 'axios';
import I18n from 'i18n-js';
import * as Routes from '@/modules/routes';
import SessionPopup from '@/components/common/SessionPopup';
import showToast from '@/components/common/Toast';

interface Props {
  isOpen: boolean;
  sessionId: string;
  onEndSuccess: () => void;
  onRejoinClick: () => void;
}

// AIDEV-NOTE: PLAT-17264 — Non-dismissable host popup (no onClose → no Esc/backdrop/X dismiss,
// forces a clear choice). DELETE reuses the slideshow End Session endpoint (PLAT-16721).
const TeacherSessionActivePopup = ({
  isOpen,
  onEndSuccess,
  onRejoinClick,
  sessionId,
}: Props) => {
  const [isEnding, setIsEnding] = useState(false);

  const handleEndClick = async () => {
    if (isEnding) return;
    setIsEnding(true);
    try {
      await Axios.delete(Routes.plato_api_live_session_path(sessionId));
      onEndSuccess();
    } catch {
      showToast(I18n.t('end_session_error'), { msgType: 'error' });
      setIsEnding(false);
    }
  };

  return (
    <SessionPopup
      body={I18n.t('teacher_paced_mode_live_body')}
      headline={{
        id: 'teacher-paced-mode-live-headline',
        text: I18n.t('teacher_paced_mode_live_headline'),
      }}
      isOpen={isOpen}
      primaryButton={{
        onClick: onRejoinClick,
        text: I18n.t('rejoin_session_button'),
      }}
      secondaryButton={{
        onClick: handleEndClick,
        text: I18n.t('end_session'),
        variant: 'red',
      }}
    />
  );
};

export default TeacherSessionActivePopup;
